import React from 'react'
import { LuBriefcase, LuBuilding2, LuGlobe, LuVideo } from 'react-icons/lu'
import hr from "../../../images/students/hrs.webp"


export default function Speaciality() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full  overflow-hidden text-center'>
            <img src={hr} alt='banner' loading='lazy' className='mx-auto object-cover w-[90px] md:w-[135px]' />
            <h5 className='text-[#000000] font-semibold text-[22px] md:text-[30px]'>Learn From Industry Specialists</h5>
            <div className='mt-[20px] md:mt-[50px] flex gap-[22px] flex-wrap justify-center items-center text-[#1E2939] text-[15px] md:text-[18px] font-semibold'>
                <div className='w-full md:w-[420px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <div className='bg-[#DBEAFE] size-[42px] md:size-[55px] rounded-[8px] md:rounded-[15px] flex justify-center items-center text-[#155DFC]'>
                        <LuGlobe className='size-[20px] md:size-[25px]' />
                    </div>
                    <p className='mt-[10px] md:mt-[18px]'>Real-world exposure from professionals</p>
                </div>
                <div className='w-full md:w-[420px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <div className='bg-[#F3E8FF] size-[42px] md:size-[55px] rounded-[8px] md:rounded-[15px] flex justify-center items-center text-[#9810FA]'>
                        <LuBuilding2 className='size-[20px] md:size-[25px]' />
                    </div>
                    <p className='mt-[10px] md:mt-[18px]'>Working in leading companies</p>
                </div>
                <div className='w-full md:w-[420px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <div className='bg-[#FFEDD4] size-[42px] md:size-[55px] rounded-[8px] md:rounded-[15px] flex justify-center items-center text-[#F54900]'>
                        <LuBriefcase className='size-[20px] md:size-[25px]' />
                    </div>
                    <p className='mt-[10px] md:mt-[18px]'>Adds industry context to academics</p>
                </div>
                <div className='w-full md:w-[420px] p-[15px] md:py-[30px] border-[1px] border-[#E9EAEB] rounded-[12px] md:rounded-[18px] flex flex-col justify-center items-center'>
                    <div className='bg-[#DCFCE7] size-[42px] md:size-[55px] rounded-[8px] md:rounded-[15px] flex justify-center items-center text-[#00A63E]'>
                        <LuVideo className='size-[20px] md:size-[25px]' />
                    </div>
                    <p className='mt-[10px] md:mt-[18px]'>Shows how skills are used in real environments</p>
                </div>
            </div>
        </div>
    )
}
